// admin 参考脸上传 — suite-generation-workflow task 4.2
//
// 套系工作流的「参考脸」需要一张 OSS 签名读 URL (reference_face_url) 传给
// plate autogen, 引擎据此把每张底版 ForceFaceSwap 成统一模特脸。
//
// 这里走后端中转上传 (前端 POST 文件 → 后端用 AK/SK PutObject 到 OSS → 返回
// 签名读 URL), AK/SK 不出后端, 前端不拼 OSS POST policy。
//
// TODO(suite-generation-workflow task 3.1): 后端需暴露 admin 侧参考脸上传端点
//   `POST /admin/v1/uploads/face` (multipart, 字段 file), 返回 { url } (OSS 签名
//   读 URL)。当前用户侧只有 `/api/v1/uploads/face` (需真实用户鉴权), admin server
//   尚未挂载等价路由。端点就绪前, 运营可在表单里直接粘贴一张 OSS 签名读 URL。
//   若后端最终只返回 { key }(非签名 URL), 需要再加一步现签 (或后端直接返回 url)。

import axios from 'axios';
import { env } from '@/utils/env';
import { useAuthStore } from '@/stores/auth';

export interface UploadFaceResult {
  /** OSS 签名读 URL, 直接作为 reference_face_url。 */
  url: string;
}

/**
 * 上传一张参考脸到 OSS, 拿签名读 URL。
 *
 * 不复用 `@/api/client` 的共享 axios 实例: 它默认 `Content-Type: application/json`,
 * 会盖掉浏览器给 FormData 自动生成的 multipart boundary。这里用裸 axios + 手动带上
 * admin token, 让浏览器自行设置 multipart/form-data;boundary。
 */
export async function uploadReferenceFace(file: File): Promise<UploadFaceResult> {
  const fd = new FormData();
  fd.append('file', file);
  fd.append('content_type', file.type || 'image/jpeg');

  const token = useAuthStore.getState().token;
  const res = await axios.post(`${env.apiBase || ''}/admin/v1/uploads/face`, fd, {
    headers: token
      ? { 'X-Touliu-Admin-Token': token, Authorization: `Bearer ${token}` }
      : undefined,
    timeout: 60_000,
  });

  // 后端信封 { code, data: { url } }; 兜底裸 { url }。
  const body = res.data;
  const url: string = body?.data?.url ?? body?.url ?? '';
  if (!url) {
    throw new Error('上传成功但未返回签名 URL, 请检查后端 /admin/v1/uploads/face 返回结构');
  }
  return { url };
}
